
export function LegacyAudioWaveIcon() {
  return (
    <svg aria-hidden="true" focusable="false" viewBox="0 0 26 25">
      <g fillRule="evenodd" stroke="none" strokeWidth="1">
        <g>
          <path
            d="M12.815,0.999 C12.3283871,0.798492488 11.76897,0.909666292 11.396,1.281 L5.809,7.392 L1.904,7.392 C1.189,7.392 0.603,7.978 0.603,8.691 L0.603,16.483 C0.603,17.197 1.189,17.782 1.904,17.782 L5.809,17.782 L11.396,23.896 C11.7686979,24.2668001 12.3277203,24.3772977 12.8134649,24.1761793 C13.2992095,23.9750609 13.6165035,23.501732 13.618,22.976 L13.618,2.198 C13.618,1.675 13.302,1.198 12.815,1 L12.815,0.999 Z"
            fillRule="nonzero"
          />
          <path
            className="ic-audio-wave-s"
            d="M20.125,12.587 C20.1194894,10.4344624 18.3735443,8.69209512 16.221,8.691 L16.221,11.288 C16.938,11.288 17.522,11.871 17.522,12.587 C17.522,13.303 16.938,13.886 16.221,13.886 L16.221,16.483 C18.3739993,16.4830045 20.1205881,14.7399948 20.125,12.587 Z"
          />
          <path
            className="ic-audio-wave-m"
            d="M16.22,3.496 L16.22,6.094 C19.809,6.094 22.728,9.008 22.728,12.587 C22.728,16.167 19.809,19.081 16.221,19.081 L16.221,21.678 C21.245,21.678 25.331,17.601 25.331,12.587 C25.331,7.575 21.245,3.497 16.221,3.497 L16.22,3.496 Z"
          />
        </g>
      </g>
    </svg>
  )
}
